import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AngularFirestore } from '@angular/fire/firestore';

@Component({
  selector: 'app-yt-videos',
  templateUrl: './yt-videos.component.html',
  styleUrls: ['./yt-videos.component.scss']
})
export class YtVideosComponent implements OnInit {
  videoURLs = [];
  tests = [];
  constructor(private sanitize: DomSanitizer, private firestore: AngularFirestore) {
    const ids = ["DhU_1HJ0uQw/"]
    this.videoURLs= ids.map(id => {
      return sanitize.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + id)
    })
    firestore.collection('tests')
      .get().toPromise()
      .then(subjects => {
        subjects.docs.forEach(s => {
          let tests = s.data().tests;
          tests.forEach(t => this.tests.push(t))
          this.tests.forEach((t, i) => {
            if (i === 0)
              t.ids = [
                "YtUPwCNsx8A",
                "9dm7KV_jZ8o",
                "u_zW6LrpnhA",
                "hwHXnKXr-eI",
                "1S40DRGm81w",
                "9jRqzWGFIOU",
                "pNvOCRRBpAQ",
                "Yg8CC2FOZ7w",
                "liz_He9vuss",
                "Z75Yj0S9TjU",
                "sLrfJnfEaV4",
                "69JEhMHINGk",
                "ASg4erDhRc0",
                "22_OwVv8lLc",
                "VI6qNw0-Oxw",
                "WMcwpIWs5rk",
                "7VevC1HWEhk",
                "Nhqmi0jsYpE",
                "QReEOBviM38",
                "oPKoLhHMEtY"
              ];
            else
              t.ids = [
                "rXkAnAd2J4k",
                "RbCmNNgbXSM",
                "Fv7Pk-V1FdY",
                "LBZWyvzz26E",
                "x_2Kp-_wrxk",
                "XSzHjuguBGc",
                "f0-6wkq3Ft0",
                "pPeP5Nrd_Rk",
                "-qgnjKtUXbA",
                "V-3BEV96fRQ",
                "mgNpRijzIY4",
                "ngyS-op8T5c",
                "U6YQVt9HWIY",
                "i5vYyE_FISo",
                "oiIUGyonG54",
                "LYRkKYlZW1o",
                "5MgtwRfYH5c",
                "YzzMlLXoLTY",
                "uCOGnJk1F-8",
                "YfaA6FP9-K0"
              ];
            t.videoURLs = t.ids.map(id => {
              return sanitize.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + id)
            })
          })
        })
        console.log(this.tests)
      })
  }

  ngOnInit(): void {
  }

}
